import { ImgSrc } from "@config/image";
import {
  getPriceBySKU,
  getProductDescriptionBySKU,
  getProductImageBySKU,
  getProductNameBySKU,
  getProductShopUrlBySKU,
} from "@content/en/Options";
import Head from "next/head";

const ProductSchema = ({ sku }: { sku: string }) => {
  const productSKU = sku.toUpperCase();

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: getProductNameBySKU(productSKU),
    image: `${process.env.NEXT_PUBLIC_SITE_URL}${ImgSrc(getProductImageBySKU(productSKU))}`,
    description: getProductDescriptionBySKU(productSKU),
    sku: productSKU,
    brand: { "@type": "Brand", name: "Blues" },
    url: `${process.env.NEXT_PUBLIC_SITE_URL}/datasheets/notecard-datasheet/${productSKU.toLowerCase()}/`,
    isRelatedTo: {
      "@type": "Product",
      url: getProductShopUrlBySKU(productSKU),
    },
    offers: {
      "@type": "Offer",
      url: getProductShopUrlBySKU(productSKU),
      priceCurrency: "USD",
      price: getPriceBySKU(productSKU),
      itemCondition: "https://schema.org/NewCondition",
      availability: "https://schema.org/InStock",
    },
  };

  const schemaString = JSON.stringify(productSchema);

  return (
    <Head>
      <script key="product-jsonld" type="application/ld+json">
        {schemaString}
      </script>
    </Head>
  );
};

export default ProductSchema;
